import { createContext, Dispatch } from 'react';
import {
  GraphIntervalType,
  GraphContextModel,
  RangeType,
  GraphPage,
  FlowUnitsAPIType,
  PressureUnitsAPIType,
} from '@shared/models';

export const GraphReducerDefaultValues = {
  interval: GraphIntervalType.Auto,
  flowUnit: 'LitresPerSecond',
  pressureUnit: 'Bar',
  maintenanceSiteIds: null as number[],
  maintenanceTimeRange: RangeType.Last7Days,
  graphPage: GraphPage.Main,
} as GraphContextModel;

export enum GraphActionType {
  SetInterval = 'SetInterval',
  SetFlowUnit = 'SetFlowUnit',
  SetPressureUnit = 'SetPressureUnit',
  SetMaintenanceSiteIds = 'SetMaintenanceSiteIds',
  SetMaintenanceRangeType = 'SetMaintenanceRangeType',
  SetGraphPage = 'SetGraphPage',
}

type State = GraphContextModel;
type Action = {
  type: GraphActionType;
  payload: GraphIntervalType | FlowUnitsAPIType | PressureUnitsAPIType | number[] | RangeType | GraphPage;
};

export const graphReducer = (state: State, action: Action): State => {
  const { type, payload } = action;
  switch (type) {
    case GraphActionType.SetInterval:
      return {
        ...state,
        interval: payload as GraphIntervalType,
      };
    case GraphActionType.SetFlowUnit:
      return {
        ...state,
        flowUnit: payload as FlowUnitsAPIType,
      };
    case GraphActionType.SetPressureUnit:
      return {
        ...state,
        pressureUnit: payload as PressureUnitsAPIType,
      };
    case GraphActionType.SetMaintenanceSiteIds:
      return {
        ...state,
        maintenanceSiteIds: payload as number[],
      };
    case GraphActionType.SetMaintenanceRangeType:
      return {
        ...state,
        maintenanceTimeRange: payload as RangeType,
      };
    case GraphActionType.SetGraphPage:
      return {
        ...state,
        graphPage: payload as GraphPage,
      };
    default:
      return state;
  }
};

export const GraphContext = createContext<{
  state?: State;
  dispatch?: Dispatch<Action>;
}>({});
